/* =========================================================
   CHEFKOCH-GEWÜRZE
   Lieferzeit / Lagerbestand V2 – Cart Aware + Bundle Hard Stop
   ========================================================= */

document.addEventListener('DOMContentLoaded', initCkDeliveryV2);

function initCkDeliveryV2() {
  document.querySelectorAll('product-info').forEach(function (productInfo) {
    const mapEl = productInfo.querySelector('[data-variant-delivery-map-v2]');
    const box = productInfo.querySelector('[data-variant-delivery]');

    if (!mapEl || !box) return;
    if (productInfo.dataset.ckDeliveryV2Initialized === 'true') return;

    let payload;

    try {
      payload = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    if (
      !payload ||
      !['inventory-v2', 'inventory-v2-cart-aware'].includes(payload.engine) ||
      !payload.variants
    ) {
      return;
    }

    const form = productInfo.querySelector('form[data-type="add-to-cart-form"]');
    const quantityInput = productInfo.querySelector('input[name="quantity"]');
    const statusEl = box.querySelector('[data-delivery-status]');
    const timeEl = box.querySelector('[data-delivery-time]');
    const dotEl = box.querySelector('[data-delivery-dot]');

    if (!form || !quantityInput || !statusEl || !timeEl || !dotEl) return;

    const addButton = form.querySelector('[name="add"]');
    const originalQuantityMax = quantityInput.getAttribute('max');

    productInfo.dataset.ckDeliveryV2Initialized = 'true';

    function getShortageDelivery(sku) {
      const value = (sku || '').trim();

      if (value.endsWith('x1')) {
        return {
          status: 'Sonderabfüllung – exklusiv für dich',
          time: 'Versand in ca. 7–10 Werktagen',
          tone: 'red'
        };
      }

      if (
        value.endsWith('xMH') ||
        value.endsWith('xM') ||
        value.endsWith('xK') ||
        value.endsWith('xS') ||
        value.endsWith('xL') ||
        value.endsWith('xD')
      ) {
        return {
          status: 'Frisch für dich produziert',
          time: 'Versand in 5–7 Werktagen',
          tone: 'orange'
        };
      }

      return {
        status: 'Wird für dich vorbereitet',
        time: 'Versand in 5–7 Werktagen',
        tone: 'orange'
      };
    }

    function getCurrentVariantData() {
      const idInput = form.querySelector('input[name="id"]');
      if (!idInput) return null;

      return payload.variants[String(idInput.value)] || null;
    }

    function getHardStopInfo(data) {
      const active =
        data &&
        data.bundle === true &&
        data.hardStop === true;

      if (!active) {
        return {
          active: false,
          available: null
        };
      }

      const raw = Number(data.hardStopAvailable);

      const available = Number.isFinite(raw)
        ? Math.max(0, Math.floor(raw))
        : 0;

      return {
        active: true,
        available
      };
    }

    function setHardStopButtonBlocked(blocked) {
      if (!addButton) return;

      if (blocked) {
        if (addButton.dataset.ckHardStopBlocked !== 'true') {
          addButton.dataset.ckHardStopBlocked = 'true';

          addButton.dataset.ckHardStopPrevDisabled =
            addButton.disabled ? 'true' : 'false';

          addButton.dataset.ckHardStopPrevAriaDisabled =
            addButton.getAttribute('aria-disabled') || '';
        }

        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');

        return;
      }

      if (addButton.dataset.ckHardStopBlocked === 'true') {
        const wasDisabled =
          addButton.dataset.ckHardStopPrevDisabled === 'true';

        const previousAria =
          addButton.dataset.ckHardStopPrevAriaDisabled || '';

        addButton.disabled = wasDisabled;

        if (previousAria) {
          addButton.setAttribute('aria-disabled', previousAria);
        } else {
          addButton.removeAttribute('aria-disabled');
        }

        delete addButton.dataset.ckHardStopBlocked;
        delete addButton.dataset.ckHardStopPrevDisabled;
        delete addButton.dataset.ckHardStopPrevAriaDisabled;
      }
    }

    function applyHardStopControls(data, quantity) {
      const hardStop = getHardStopInfo(data);

      if (!hardStop.active) {
        if (originalQuantityMax === null) {
          quantityInput.removeAttribute('max');
        } else {
          quantityInput.setAttribute('max', originalQuantityMax);
        }

        setHardStopButtonBlocked(false);

        return {
          active: false,
          available: null,
          blocked: false
        };
      }

      if (hardStop.available > 0) {
        quantityInput.setAttribute(
          'max',
          String(hardStop.available)
        );
      } else {
        /*
          min=1 und max=0 wäre ein ungültiger Zahlenbereich.
          Bei 0 sperren wir deshalb den Kaufbutton hart.
        */
        quantityInput.setAttribute('max', '1');
      }

      const blocked =
        hardStop.available <= 0 ||
        quantity > hardStop.available;

      setHardStopButtonBlocked(blocked);

      return {
        active: true,
        available: hardStop.available,
        blocked
      };
    }

    function updateDeliveryV2() {
      const data = getCurrentVariantData();

      if (!data) return;

      const quantity =
        Math.max(
          1,
          parseInt(quantityInput.value, 10) || 1
        );

      const available =
        Number(data.available) || 0;

      const tracked =
        data.tracked === true;

      const policy =
        data.policy || 'deny';

      const hardStop =
        applyHardStopControls(data, quantity);

      let result;

      /*
        Ein Hard Stop hat immer Vorrang vor
        der normalen Lieferlogik.
      */
      if (
        hardStop.active &&
        hardStop.available <= 0
      ) {
        result = {
          status: 'Momentan nicht lieferbar',
          time: '',
          tone: 'red'
        };
      } else if (
        hardStop.active &&
        quantity > hardStop.available
      ) {
        result = {
          status:
            'Nur ' +
            hardStop.available +
            ' Stück verfügbar',
          time: '',
          tone: 'red'
        };
      } else if (!tracked) {
        result = {
          status: 'Sofort verfügbar',
          time: 'Versand in 1–2 Werktagen',
          tone: 'green'
        };
      } else if (policy === 'deny') {
        if (available <= 0) {
          result = {
            status: 'Momentan nicht lieferbar',
            time: '',
            tone: 'red'
          };
        } else if (quantity <= available) {
          result = {
            status: 'Sofort verfügbar',
            time: 'Versand in 1–2 Werktagen',
            tone: 'green'
          };
        } else {
          result = {
            status:
              'Nur ' +
              available +
              ' Stück verfügbar',
            time: 'Versand in 1–2 Werktagen',
            tone: 'orange'
          };
        }
      } else {
        result =
          quantity <= available
            ? {
                status: 'Sofort verfügbar',
                time: 'Versand in 1–2 Werktagen',
                tone: 'green'
              }
            : getShortageDelivery(data.sku);
      }

      /*
        Overrides bleiben wie bisher erhalten –
        ausser wenn der Hard Stop den Verkauf sperrt.
      */
      if (!hardStop.blocked) {
        if (data.overrideStatus) {
          result.status = data.overrideStatus;
        }

        if (data.overrideTime) {
          result.time = data.overrideTime;
        }

        if (data.overrideTone) {
          result.tone = data.overrideTone;
        }
      }

      statusEl.textContent =
        result.status || '';

      timeEl.textContent =
        result.time || '';

      dotEl.setAttribute(
        'data-tone',
        result.tone || 'green'
      );
    }

    /*
      Zusätzliche Sperre direkt am Produktformular.

      Dadurch kann eine manuell eingetippte Menge
      oberhalb des Hard Stops nicht abgeschickt werden.
    */
    form.addEventListener(
      'submit',
      function (event) {
        const data =
          getCurrentVariantData();

        if (!data) return;

        const quantity =
          Math.max(
            1,
            parseInt(quantityInput.value, 10) || 1
          );

        const hardStop =
          getHardStopInfo(data);

        if (
          hardStop.active &&
          (
            hardStop.available <= 0 ||
            quantity > hardStop.available
          )
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();

          updateDeliveryV2();
        }
      },
      true
    );

    let cartRefreshRunning = false;
    let cartRefreshQueued = false;

    async function refreshDeliveryFromCart() {
      if (cartRefreshRunning) {
        cartRefreshQueued = true;
        return;
      }

      const sectionId =
        productInfo.dataset.section;

      const productUrl =
        productInfo.dataset.url ||
        window.location.pathname;

      if (!sectionId || !productUrl) return;

      cartRefreshRunning = true;

      try {
        const separator =
          productUrl.includes('?')
            ? '&'
            : '?';

        const response =
          await fetch(
            productUrl +
              separator +
              'section_id=' +
              encodeURIComponent(sectionId),
            {
              method: 'GET',
              credentials: 'same-origin',
              headers: {
                'X-Requested-With':
                  'XMLHttpRequest'
              }
            }
          );

        if (!response.ok) return;

        const html =
          await response.text();

        const freshDocument =
          new DOMParser().parseFromString(
            html,
            'text/html'
          );

        const freshMapEl =
          freshDocument.querySelector(
            '[data-variant-delivery-map-v2]'
          );

        if (!freshMapEl) return;

        let freshPayload;

        try {
          freshPayload =
            JSON.parse(
              freshMapEl.textContent
            );
        } catch (e) {
          return;
        }

        if (
          !freshPayload ||
          ![
            'inventory-v2',
            'inventory-v2-cart-aware'
          ].includes(
            freshPayload.engine
          ) ||
          !freshPayload.variants
        ) {
          return;
        }

        payload = freshPayload;

        updateDeliveryV2();
      } catch (error) {
        console.warn(
          'CK Lieferzeit: Warenkorbstatus konnte nicht aktualisiert werden.',
          error
        );
      } finally {
        cartRefreshRunning = false;

        if (cartRefreshQueued) {
          cartRefreshQueued = false;

          refreshDeliveryFromCart();
        }
      }
    }

    quantityInput.addEventListener(
      'input',
      updateDeliveryV2
    );

    quantityInput.addEventListener(
      'change',
      updateDeliveryV2
    );

    const quantityBox =
      quantityInput.closest(
        'quantity-input'
      );

    if (quantityBox) {
      quantityBox.addEventListener(
        'click',
        function () {
          requestAnimationFrame(
            updateDeliveryV2
          );
        }
      );
    }

    productInfo.addEventListener(
      'change',
      function (event) {
        if (
          event.target === quantityInput
        ) {
          return;
        }

        requestAnimationFrame(
          updateDeliveryV2
        );
      }
    );

    document.addEventListener(
      'variant:change',
      updateDeliveryV2
    );

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        refreshDeliveryFromCart
      );
    }

    updateDeliveryV2();
  });
}